<template>
  <div class="bottomButton">
    <a :href="`tel:${phone}`">
      <div class="phone">
        <img src="@/assets/images/phone.png" alt="" />电话咨询
      </div>
    </a>
    <div v-if="word" class="oneline" id="openLocation" @click="$emit('right-click')">
      <img :src="pic" alt="" />{{ word }}
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomButton",

  props: {
    word: {
      required: true,
      type: String
    },
    pic: {
      required: true,
      type: String
    },
    phone: {
      required: true
    }
  },
  methods: {},
  mounted() {
    console.log(this.phone);
  }
};
</script>

<style lang="scss" scoped>
.bottomButton {
  width: 100%;
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  a {
    flex: 1;
    .phone {
      height: 100%;
      background-color: #ffd63c;
      line-height: 50px;
      opacity: 1;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      color: #543302;

      img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }

  .oneline {
    flex: 1;
    background-color: #7dceff;
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #024154;
    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
</style>
